<template>
  <b-container fluid>
    <b-row>
      <b-col lg="12" sm="12">
        <b-row>
            <b-col lg="10" offset-lg="1" sm="12">
                <b-overlay :show="loading">
                    <ValidationObserver ref="form"  v-slot="{ handleSubmit, reset }">
                        <b-form  @submit.prevent="handleSubmit(register)" @reset.prevent="reset" >
                        <ValidationProvider name="Title" vid="title" rules="required">
                            <b-form-group class="row" label-cols-sm="12" slot-scope="{ valid, errors }">
                                <template v-slot:label>Title <span class="text-danger">*</span></template>
                                <b-form-input v-model="formData.title" :state="errors[0] ? false : (valid ? true : null)"></b-form-input>
                                <div class="invalid-feedback">{{ errors[0] }}</div>
                            </b-form-group>
                        </ValidationProvider>
                        <ValidationProvider name="Link" vid="link" rules="required">
                            <b-form-group class="row" label-cols-sm="12" slot-scope="{ valid, errors }">
                                <template v-slot:label>Link <span class="text-danger">*</span></template>
                                <b-form-input v-model="formData.link" :state="errors[0] ? false : (valid ? true : null)"></b-form-input>
                                <div class="invalid-feedback">{{ errors[0] }}</div>
                            </b-form-group>
                        </ValidationProvider>
                        <ValidationProvider name="Points" vid="points" rules="required|min_value:0">
                            <b-form-group class="row" label-cols-sm="12" slot-scope="{ valid, errors }">
                                <template v-slot:label>Points <span class="text-danger">*</span></template>
                                <b-form-input type="number" step="0.01" v-model="formData.points" :state="errors[0] ? false : (valid ? true : null)"></b-form-input>
                                <div class="invalid-feedback">{{ errors[0] }}</div>
                            </b-form-group>
                        </ValidationProvider>
                        <div class="row">
                            <div class="col-sm-3"></div>
                            <div class="col text-right">
                            <b-button type="submit" variant="primary" class="mr-2">{{ saveBtnName }}</b-button>
                            &nbsp;
                            <b-button variant="danger" class="mr-1" @click="$bvModal.hide('modal-1')">Close</b-button>
                            </div>
                        </div>
                        </b-form>
                    </ValidationObserver>
                </b-overlay>
            </b-col>
        </b-row>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import RestApi, { baseUrl } from '../../config/api_config'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import iziToast from 'izitoast';
export default {
  props: ['id'],
  components: {
    ValidationObserver,
    ValidationProvider
  },
  created () {
      if (this.id) {
          this.formData = this.getItem()
      }
  },
  data () {
    return {
      saveBtnName: this.id ? 'Update' : 'Save',
      formData: {
        title: '',
        link: '',
        points: 0
      }
    }
  },
  computed: {
      loading () {
        return this.$store.state.static.loading
      }
  },
  methods: {
    getItem () {
        const item = this.$store.state.list.find(item => item.id === parseInt(this.id))
        return JSON.parse(JSON.stringify(item))
    },
    async register () {
        this.$store.dispatch('mutedLoad', { loading: true, listReload: false })
        let result = null
        if (this.id) {
            result = await RestApi.putData(baseUrl, `${'api/game-links/update'}/${this.id}`, this.formData)
        } else {
            result = await RestApi.postData(baseUrl,'api/game-links/store', this.formData)
        }
        this.$store.dispatch('mutedLoad', { loading: false, listReload: true })
        if (result.success) {
            if (!this.id) {
                this.formData.title = ''
                this.formData.link = ''
                this.formData.points = 0
            }
            iziToast.success({
                title: 'Success',
                message: result.message
            })
             this.$bvModal.hide('modal-1')
        } else {
            this.$refs.form.setErrors(result.errors)
        }
    }
  }
}
</script>
